// Builds the final title sent to POST /tickets/details.
export const buildSubmitTitle = (titlePrefix, title) => {
  const trimmedTitle = (title ?? '').trim();
  const trimmedPrefix = (titlePrefix ?? '').trim();

  if (!trimmedPrefix) {
    return trimmedTitle;
  }

  if (trimmedTitle.toLowerCase().startsWith(trimmedPrefix.toLowerCase())) {
    return trimmedTitle;
  }

  return `${trimmedPrefix} ${trimmedTitle}`;
};
